// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <h1>Pethowz</h1>
//     </div>
//   );
// }

// export default App;



import { createTheme, ThemeProvider } from '@mui/material';
import './App.css';

import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import LoginComponent from './Pages/Login/LoginComponent';
// import AdminLayout from './Pages/Admin/AdminLayout';
import Layout from './Components/Layout/Layout';
import { Dashboard } from '@mui/icons-material';
import Designation from './Pages/Admin/Master/Designation/Designation';
// import Employee from './Pages/Employee/Employee';
import EmployeeLogin from './Pages/Login/EmployeeLogin';
import EmployeeLayout from './Components/Layout/EmployeeLayout';
import ProtectedAdminRoute from './Components/Layout/ProtectedAdminRoute';
import { adminUrl } from './constants';
import actions from './ReduxStore/actions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import staticLogo from "./Assets/logo.png"
import ProtectedEmployeeRoute from './Components/Layout/ProtectedEmployeeRoute';
import ProtectedRoute from './Components/Layout/ProtectedRoute';
import UnAuthorized from './Components/Layout/UnAuthorized';



const theme = createTheme({
  typography: {
    fontFamily: "Roboto, Arial, sans-serif", // Default font for body
    h1: {
      fontFamily: "Poppins",
      fontWeight: "200",
      fontSize: "50px",
      [`@media (max-width:600px)`]: {
        fontSize: "40px", // Larger font size for larger screens
      },
    },
    h2: {
      fontFamily: "Poppins",
      fontWeight: "medium",
      fontSize: "40px",
      [`@media (max-width:600px)`]: {
        fontSize: "30px", // Larger font size for larger screens
      },
    },
    h3: {
      fontFamily: "Poppins",
      fontWeight: "bold",
      fontSize: "33px",
      [`@media (max-width:600px)`]: {
        fontSize: "22px", // Larger font size for larger screens
      },
    },
    h6: {
      fontFamily: "Poppins",
      fontWeight: "medium",
      fontSize: "18px",
      color: "#252525",
      [`@media (max-width:600px)`]: {
        fontSize: "16px", // Larger font size for larger screens
      },
    },
    h5: {
      fontFamily: "Poppins",
      fontWeight: "medium",
      fontSize: "16px",
      color: "#9c9ca2",
      [`@media (max-width:600px)`]: {
        fontSize: "14px", // Larger font size for larger screens
      },
    },

    body1: {
      fontFamily: "sans-serif",
      fontWeight: "normal",
      fontSize: "14px",
      color: "#b4b4b7",
      [`@media (max-width:600px)`]: {
        fontSize: "11px", // Larger font size for larger screens
      },
    },
    body2: {
      fontFamily: "Roboto",
      fontWeight: "bold",
      fontSize: "16px",
      [`@media (max-width:600px)`]: {
        fontSize: "14px", // Larger font size for larger screens
      },
    },
    subtitle1: {
      fontFamily: "Roboto",
      fontWeight: "normal",
      fontSize: "15px",
      [`@media (max-width:600px)`]: {
        fontSize: "13px", // Larger font size for larger screens
      },
    },
    subtitle2: {
      fontFamily: "poppins",
      fontWeight: "normal",
      fontSize: "14px",
      [`@media (max-width:600px)`]: {
        fontSize: "12px", // Larger font size for larger screens
      },
    },
    customText: {
      fontFamily: "Poppins", // Custom font
      fontWeight: "medium",
      fontSize: "16px",
      color: "#6f6c6c",
      [`@media (max-width:600px)`]: {
        fontSize: "12px", // Larger font size for larger screens
      },
    },
    footerText: {
      fontFamily: "poppins",
      fontWeight: "normal",
      fontSize: "14px",
      [`@media (max-width:600px)`]: {
        fontSize: "12px", // Larger font size for larger screens
      },
    },
    button: {
      fontFamily: "sans-serif", // Buttons will use Poppins
      fontWeight: "normal",
      textTransform: "uppercase", // Optional: makes text uppercase
      fontSize: "16px",

      [`@media (max-width:600px)`]: {
        fontSize: "12px", // Larger font size for larger screens
      },
    },
  },
  components: {
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       fontFamily: "Poppins", // Ensure Poppins applies to buttons
    //       fontWeight: "bold",
    //       fontSize: "0.875rem",
    //       textTransform: "uppercase", // Optional: uppercase for buttons
    //     },
    //   },
    // },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          listStyle: "none",
          fontFamily: "Poppins", // Custom font
          fontWeight: "medium",
          fontSize: "17px",
          color: "#6f6c6c"
        },
      },
    },
    // MuiListItem: {
    //   styleOverrides: {
    //     primary: {
    //       fontFamily: "Poppins", // Custom font
    //       fontWeight: "medium",
    //       fontSize: "16px",
    //     },
    //   },
    // },
    MuiListItem: {
      styleOverrides: {
        root: {
          fontFamily: "poppins",
          fontWeight: "400", // Use number instead of "medium"
          color: "gray",
          fontSize: "15px",
          color: "#6f6c6c", // Add this if needed
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "Roboto", // Menu items use Roboto
          fontSize: "1rem",
          fontWeight: "normal",
        },
      },
    },
  },
});




function App() {

  // const location = useLocation();

  // // Check if current route is the one where header and footer should be hidden
  // const hideHeaderFooter = location.pathname.match(/^\/petboardspaces\/[^/]+\/petdetails$/) ||
  //   location.pathname === "/login" ||
  //   location.pathname === "/register" ||
  //   location.pathname === "/joinpethost" ||
  //   location.pathname === "/becomepethost";

  const { saveSiteSettings } = useSelector(
    (state) => state?.saveSiteSettings
  );

  const { getSiteSettings } = useSelector(
    (state) => state?.getSiteSettings
  );

  console.log(getSiteSettings, "getSiteSettings")
  const dispatch = useDispatch()
  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: `getSiteSettings`
      };
      const response = await dispatch(actions.GETADMINSITESETTINGS(data1));
      console.log(response?.payload?.data?.favicon, "responsedataaaaaaa")
      if (response?.payload?.message === "Site settings fetched successfully.") {
        let link = document.querySelector("link[rel~='icon']");

        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }

        link.href = `${adminUrl}${response?.payload?.data?.favicon}` || '';
        // Dynamically set CSS variables
        const root = document.documentElement;
        if (response?.payload?.data?.primary_color) {
          root.style.setProperty('--main-color', response?.payload?.data?.primary_color || '#28a8e0');
          // root.style.setProperty('--table-headbackgroungcolor', siteData.theme.tableHeadBackgroundColor || 'gray');
          // root.style.setProperty('--main-contentbackgroundcolor', siteData.theme.mainContentBackgroundColor || '#edf2f6');
        }
      }

    }
    fetchData()

  }, [saveSiteSettings])

  const dynamicLogo = getSiteSettings?.data?.logo ? `${adminUrl}${getSiteSettings?.data?.logo}` : staticLogo;
  console.log(dynamicLogo, "dynamicLogo")
  // const dynamiBanner = `${adminUrl}${getSiteSettings?.data?.banner_image}` || staticLBanner;
  // const dynamicCampusName = `${getSiteSettings?.data?.company_name}` || "Cygnusa";





  return (

    <ThemeProvider theme={theme}>

      {/* {!hideHeaderFooter && <MyAppBar />} */}

      <Routes>
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              {/* <AdminDashboard /> */}
              <Layout dynamicLogo={dynamicLogo} />
            </ProtectedRoute>

            // <ProtectedAdminRoute>
            //   <Layout dynamicLogo={dynamicLogo} />
            // </ProtectedAdminRoute>
          }
        />
        <Route path="/" element={<LoginComponent dynamicLogo={dynamicLogo} />} />
        {/* <Route path="/admin/*" element={<Layout dynamicLogo={dynamicLogo}/>} /> */}
        <Route path="/employeelogin" element={<EmployeeLogin dynamicLogo={dynamicLogo} />} />
        <Route path="/unauthorized" element={<UnAuthorized dynamicLogo={dynamicLogo} />} />
        
        <Route
          path="/employee/*"
          element={
            <ProtectedRoute allowedRoles={['employee']}>
              <EmployeeLayout dynamicLogo={dynamicLogo} />
            </ProtectedRoute>

            // <ProtectedEmployeeRoute>
            //   <EmployeeLayout dynamicLogo={dynamicLogo} />
            // </ProtectedEmployeeRoute>
          }
        />
        {/* <Route path="/employee/*" element={<EmployeeLayout dynamicLogo={dynamicLogo} />} /> */}


        {/* <Route index element={<Dashboard />} /> 
          <Route path="designation" element={<Designation />} /> */}
        {/* </Route> */}

        {/* <Route path="/register" element={<RegisterPage />} />
        <Route path="/joinpethost" element={<JoinPetHost />} />
        <Route path="/becomepethost" element={<BecomePetHost />} />
        <Route path="/user" element={<Homepage />} />

        <Route path="/user" element={<PetUserMainPage />}>
          <Route index element={<Dashboard />} />
          <Route path="mypets" element={<MyPets />} />
          <Route path="addetails" element={<AddYourPetDetails />} />
          <Route path="mybookings" element={<MyBookings />} />
          <Route path="myenquiries" element={<MyEnquiries />} /> */}
      </Routes>

      {/* <Route path="/petboarduser" element={<PetBoardSpaceUsersMainPage />}>
          <Route index element={<PetBoardUserDashboard />} />
          <Route path="myprofile" element={<PetBoardSpaceUserProfile />} />
          <Route path="editPofile" element={<EditPetBoardSpaceUserProfile />} />
          <Route path="bookingsreceived" element={<BookingsReceived />} />
        </Route>
      </Routes>
      {!hideHeaderFooter && <Footer />} */}


    </ThemeProvider>

  );
}

export default App;

